import { createReducer, ActionType } from "typesafe-actions";
import * as actions from "./actions";
import initialState from "./state";
import { HighlightingState } from "./types";

type Action = ActionType<typeof actions>;

const reducer = createReducer<HighlightingState, Action>(initialState)
  .handleAction(actions.initHighlighting, (state, { payload: { filter } }) => ({
    ...initialState,
    filter,
  }))
  .handleAction(
    actions.fetchHighlights.success,
    (state, { payload: { data } }) => ({
      ...state,
      selections: data,
      initialized: true,
    }),
  )
  .handleAction(
    actions.createHighlight.request,
    (state, { payload: data }) => ({
      ...state,
      creating: true,
      activeSelectionId: data.id || null,
      selections: state.selections
        .filter((selection) => selection.id)
        .concat(data),
    }),
  )
  .handleAction(
    actions.createHighlight.success,
    (state, { payload: { data } }) => ({
      ...state,
      creating: false,
      activeSelectionId: data.id || null,
      selections: state.selections
        .filter((selection) => selection.id)
        .concat(data),
    }),
  )
  .handleAction(actions.createHighlight.failure, (state) => ({
    ...state,
    creating: false,
  }))
  .handleAction(
    actions.updateHighlight.request,
    (state, { payload: data }) => ({
      ...state,
      selections: state.selections.map((selection) =>
        selection.id === data.id ? data : selection,
      ),
    }),
  )
  .handleAction(
    actions.updateHighlight.success,
    (state, { payload: { data } }) => ({
      ...state,
      selections: state.selections.map((selection) =>
        selection.id === data.id ? data : selection,
      ),
    }),
  )
  .handleAction(actions.removeHighlight.success, (state, { payload: id }) => ({
    ...state,
    selections: state.selections.filter((selection) => selection.id !== id),
  }))
  .handleAction(actions.setSelections, (state, { payload: selections }) => ({
    ...state,
    selections,
  }))
  .handleAction(actions.setTooltipData, (state, { payload }) => ({
    ...state,
    tooltip: { ...state.tooltip, ...payload },
  }))
  .handleAction(actions.setCommentTooltipData, (state, { payload }) => ({
    ...state,
    commentTooltip: { ...state.commentTooltip, ...payload },
  }))
  .handleAction(actions.setActiveSelectionId, (state, { payload }) => ({
    ...state,
    activeSelectionId: payload,
  }))
  .handleAction(actions.showCommentTooltip, (state) => ({
    ...state,
    commentTooltip: { ...state.commentTooltip, isShown: true },
  }))
  .handleAction(actions.hideCommentTooltip, (state) => ({
    ...state,
    commentTooltip: initialState.commentTooltip,
  }));

export default reducer;
